import { render, staticRenderFns } from "./FinanceBalancesUserBalancesExtra.vue?vue&type=template&id=33b2747d&scoped=true&"
import script from "./FinanceBalancesUserBalancesExtra.vue?vue&type=script&lang=js&"
export * from "./FinanceBalancesUserBalancesExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b2747d",
  null
  
)

export default component.exports